import Axios from 'axios'

const tokenKey = 'token'

const instance = Axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    Authorization: `Bearer ${localStorage.getItem(tokenKey)}` || '',
  },
})

const login = async (payload) => {
  const result = await instance
    .post('/admin/login', payload)
    .then((res) => res.data)
  const { token } = result
  if (token) {
    localStorage.setItem(tokenKey, token)
    instance.defaults.headers['Authorization'] = `Bearer ${token}`
  }
  return result
}

const getUserInfo = async () => {
  const result = await instance.get('/admin/me').then((res) => res.data)
  return result
}

const logout = async () => {
  localStorage.removeItem(tokenKey)
  instance.defaults.headers['Authorization'] = ''
  return {}
}

export const client = instance

const authClient = {
  login,
  logout,
  getUserInfo,
  client,
}

export default authClient
